import React from 'react';
import AuditContent from "./audit-content.jsx";

const ReportContent = ({ data }) => {
    const items = data?.[0] ?? [];
    const deletedIds = new Set(items.filter(item => item.action === "Exclusão").map(item => item.entityid));

    const elements = items.map(item => ({
        ...item,
        deleted: deletedIds.has(item.entityid)
    }));

    return (
        <div>
            { elements.map((element, index) => (
                <AuditContent key={index} element={element}/>
            ))}
        </div>
    );
};

export default ReportContent;